/**
 * @fileoverview POST handler for the "/companies/:company_id/verified_domains" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postCompaniesCompanyIdVerifiedDomainsCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdVerifiedDomainsProps,
  PostCompaniesCompanyIdVerifiedDomainsResult,
} from "./types";

export const postCompaniesCompanyIdVerifiedDomains = reactQueryMutationAdapter(
  postCompaniesCompanyIdVerifiedDomainsCacheKeys,
  ({
    companyId,
    type,
    subdomain,
    rootDomain,
  }: PostCompaniesCompanyIdVerifiedDomainsProps): Promise<PostCompaniesCompanyIdVerifiedDomainsResult> => {
    return fetch(
      `/companies/${companyId}/verified_domains`,
      "POST",
      { type, subdomain, root_domain: rootDomain },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
